import { axios } from "../config";  
 
function addStaff(schoolId) {
  return axios.post(`api/auth/login/${schoolId}`);
}
 
function getStaff(schoolId) {
  return axios.get(`api/auth/login/${schoolId}`);
}

export { addStaff, getStaff };
